import * as _ from "lodash-es";
import { Moment } from "moment-timezone";
import React, { ChangeEvent, Component } from "react";
import taxJarLogo from "../../../../assets/images/taxjar/taxjar-logotype-dark.svg";
import taxJarLightLogo from "../../../../assets/images/taxjar/taxjar-logotype.svg";
import qboLogoSrc from "../../../../assets/images/quickbooks/QB_16x16.png";
import ShippingAccounts from "../ShippingAccounts/ShippingAccounts";
import ShippingUpchargeDetails from "../ShippingUpchargeDetails/ShippingUpchargeDetails";
import "./VendorSidebar.scss";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ICategory from "../../../../models/ICategory";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import SystemConst from "../../../../services/SystemConst";
import IOnUpdateVendorPriceGroupMapDTO from "../../../../models/DTO/IOnUpdateVendorPriceGroupMapDTO";
import IRebate_Group from "../../../../models/IRebate_Group";
import OwDateInput from "../../../shared/OwDateInput/OwDateInput";
import IOnProcessParentVendorTokenDTO from "../../../../models/DTO/IOnProcessParentVendorTokenDTO";
import OwButton from "../../../shared/OwButton/OwButton";
import IShipping_DetailUI from "../../../../models/IShipping_DetailUI";
import IUpdateTokenConfigurationDTO from "../../../../models/DTO/IUpdateTokenConfigurationDTO";
import IVendorModel from "../../../../models/IVendorModel";
import IGetShipstationCarriersDTO from "../../../../models/DTO/IGetShipstationCarriersDTO";
import PaymentTypeEnum from "../../../../models/PaymentTypeEnum";
import IConnection_Token from "../../../../models/IConnection_Token";
import IGetCategoriesDTO from "../../../../models/DTO/IGetCategoriesDTO";
import IShipping_AccountUI from "../../../../models/IShipping_AccountUI";
import ICatalog from "../../../../models/ICatalog";
import IQBOTaxRate from "../../../../models/QuickBooks Online/IQBOTaxRate";
import IOnGetVendorDTO from "../../../../models/DTO/IOnGetVendorDTO";
import IVendor_Price_Group_Map from "../../../../models/IVendor_Price_Group_Map";
import MasterUser from "../../../users/Users/MasterUser/MasterUser";
import { LoadingResults } from "../../../shared/LoadingResults/LoadingResults";
import IShipstationCarrierDTO from "../../../../models/Shipstation/IShipstationCarrierDTO";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IOnGetRebateGroupsDTO from "../../../../models/DTO/IOnGetRebateGroupsDTO";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import INewShipping_Account from "../../../../models/INewShipping_Account";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import IOnQBOGetClassesDTO from "../../../../models/DTO/IOnQBOGetClassesDTO";
import IOnGetShippingZonesDTO from "../../../../models/DTO/IOnGetShippingZonesDTO";
import IShipping_Zone from "../../../../models/IShipping_Zone";
import UserTypesEnum from "../../../../models/UserTypesEnum";
import IOnGetVendorPriceGroupMapDTO from "../../../../models/DTO/IOnGetVendorPriceGroupMapDTO";
import ICreateVendorDTO from "../../../../models/DTO/ICreateVendorDTO";
import TokenTypesEnum from "../../../../models/TokenTypesEnum";
import IProcessParentVendorTokenDTO from "../../../../models/DTO/IProcessParentVendorTokenDTO";
import IGetVendorPriceGroupMapDTO from "../../../../models/DTO/IGetVendorPriceGroupMapDTO";
import IOnUpdateTokenConfigurationDTO from "../../../../models/DTO/IOnUpdateTokenConfigurationDTO";
import IShipstationWarehouse from "../../../../models/Shipstation/IShipstationWarehouse";
import IQBOGetTaxRatesDTO from "../../../../models/DTO/IQBOGetTaxRatesDTO";
import ISupplierModel from "../../../../models/ISupplierModel";
import FileUploadResourceTypeEnum from "../../../../models/FileUploadResourceTypeEnum";
import IQBOGetClassesDTO from "../../../../models/DTO/IQBOGetClassesDTO";
import Typeahead from "../../../shared/Typeahead/Typeahead";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IOnGetCategoriesDTO from "../../../../models/DTO/IOnGetCategoriesDTO";
import IOnUpdateVendorDTO from "../../../../models/DTO/IOnUpdateVendorDTO";
import IGetRebateGroupsDTO from "../../../../models/DTO/IGetRebateGroupsDTO";
import IOnQBOGetTaxRatesDTO from "../../../../models/DTO/IOnQBOGetTaxRatesDTO";
import IOnGetVendorsDTO from "../../../../models/DTO/IOnGetVendorsDTO";
import IGetShippingZonesDTO from "../../../../models/DTO/IGetShippingZonesDTO";
import IPrice_Group from "../../../../models/IPrice_Group";
import TaxJarExemptionTypeEnum from "../../../../models/TaxJar/TaxJarExemptionTypeEnum";
import UIService from "../../../../services/UIService";
import IQBOClassDTO from "../../../../models/QuickBooks Online/IQBOClassDTO";
import IAddress from "../../../../models/IAddress";
import IUpdateVendorDTO from "../../../../models/DTO/IUpdateVendorDTO";
import IGetVendorsDTO from "../../../../models/DTO/IGetVendorsDTO";
import IGetVendorDTO from "../../../../models/DTO/IGetVendorDTO";
import IOnGetShipstationCarriersDTO from "../../../../models/DTO/IOnGetShipstationCarriersDTO";
import IOnShipstationListWarehousesDTO from "../../../../models/DTO/IOnShipstationListWarehousesDTO";
import OwS3Uploader from "../../../shared/OwS3Uploader/OwS3Uploader";
import INotification from "../../../../models/INotification";
import AddressBlock from "../../../shared/AddressBlock/AddressBlock";
import INewShipping_Detail from "../../../../models/INewShipping_Detail";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import IOnQBOGetTermsDTO from "../../../../models/DTO/IOnQBOGetTermsDTO";
import IUpdateVendorPriceGroupMapDTO from "../../../../models/DTO/IUpdateVendorPriceGroupMapDTO";
import OwTextArea from "../../../shared/OwTextArea/OwTextArea";
import IUserUI from "../../../../models/IUserUI";
import { Socket } from "socket.io-client";
import IUser from "../../../../models/IUser";
import { IShipstationListWarehousesDTO } from "../../../../models/DTO/IShipstationListWarehousesDTO";
import IQBOPushCustomersDTO from "../../../../models/DTO/IQBOPushCustomersDTO";
import IQBOOnPushCustomersDTO from "../../../../models/DTO/IQBOOnPushCustomersDTO";
import ITypeaheadLookupByTokenTypeDTO from "../../../../models/DTO/ITypeaheadLookupByTokenTypeDTO";
import IOnTypeaheadLookupByTokenTypeDTO from "../../../../models/DTO/IOnTypeaheadLookupByTokenTypeDTO";
import OwS3DownloadLink from "../../../shared/OwS3DownloadLink/OwS3DownloadLink";
import INewAddress from "../../../../models/INewAddress";
import { CurrencySelect } from "../../../shared/CurrencySelect/CurrencySelect";
import { DeliveryDeadlinesSection } from "./DeliveryDeadlinesSection";
import TimezonePicker from "../../../shared/TimezonePicker/TimezonePicker";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import IRoute from "../../../../models/IRoute";
import IndustryNameEnum from "../../../../models/IndustryNameEnum";
import { TypeaheadFn } from "../../../shared/TypeaheadFn/TypeaheadFn";
import IOnGetRoutesDTO from "../../../../models/DTO/IOnGetRoutesDTO";
import IGetRoutesDTO from "../../../../models/DTO/IGetRoutesDTO";
import styled from "styled-components";
import IWorkflow from "../../../../models/IWorkflow";
import IQBOCustomerDTO from "../../../../models/QuickBooks Online/IQBOCustomerDTO";
import QboService from "../../../../services/QboService";
import IOnGetWorkflowsDTO from "../../../../models/DTO/IOnGetWorkflowsDTO";
import IGetWorkflowsDTO from "../../../../models/DTO/IGetWorkflowsDTO";
import HelperService from "../../../../services/HelperService";
import OwTranslate from "../../../shared/OwTranslate/OwTranslate";
import QBOGroupedInvoiceTypeEnum from "../../../../models/QBOGroupedInvoiceTypeEnum";
import QBDBooleanStringEnum from "../../../../models/QuickBooks Desktop/QBDBooleanStringEnum";
import AccessTypesEnum from "../../../../models/AccessTypesEnum";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import IUser_Type from "../../../../models/IUser_Type";
import IRepGroup from "../../../../models/IRepGroup";
import { IGetRepGroupsDTO } from "../../../../models/DTO/IGetRepGroupsDTO";
import IOnGetRepGroupsDTO from "../../../../models/DTO/IOnGetRepGroupsDTO";
import FastBoundService, { FastBoundContactSearchField } from "../../../../services/FastBoundService";
import FastBoundDispositionTypeEnum from "../../../../models/FastBoundDispositionTypeEnum";

const fbContactSearchFields: { value: FastBoundContactSearchField; title: string }[] = [
    { value: "licenseName", title: "License Name" },
    { value: "fflNumber", title: "FFL Number" },
    { value: "organizationName", title: "Organization" },
    { value: "firstName", title: "First Name" },
    { value: "lastName", title: "Last Name" },
];

interface IFastBoundContactResult {
    id: string;
    licenseName?: string | null;
    tradeName?: string | null;
    organizationName?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    suffix?: string | null;
    fflNumber?: string | null;
    premiseCity?: string | null;
    premiseState?: string | null;
    premiseAddress1?: string | null;
    premiseZipCode?: string | null;
    isPrimaryAccountContact?: boolean;
}

const getFbContactDisplayName = (c: IFastBoundContactResult): string => {
    const name = [c.firstName, c.middleName, c.lastName, c.suffix].filter(Boolean).join(" ");
    const org = c.organizationName || c.tradeName || c.licenseName;
    return name || org || c.id;
};

const getFbContactLocation = (c: IFastBoundContactResult): string => {
    const cityState = [c.premiseCity, c.premiseState].filter(Boolean).join(", ");
    const parts = [c.premiseAddress1, cityState, c.premiseZipCode].filter(Boolean);
    return parts.join(", ");
};

type Props = {
    cancel: (refresh: boolean) => void;
    catalogs?: ICatalog[];
    supplierVendor?: IConnection_Token;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    userType: string;
    socket: Socket;
    priceGroups: IPrice_Group[];
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

type State = {
    vendorModel: IVendorModel;
    Bill_To: IAddress;
    Ship_To: IAddress;
    create_in_qbo: boolean;
    create_in_qbd: boolean;
    catalog_id?: number;
    isFormValid?: boolean;
    qboSalesTerms?: any[];
    qbo_SalesTermRef: string | null;
    qbd_TermOptionListID?: string | null;
    qbd_SalesTaxListID?: string | null;
    priceGroups: any[];
    isOnline: boolean;
    rebate_groups: IRebate_Group[];
    price_discount_one?: number | null;
    dashboard_order_entry?: boolean;
    hasTokenConfigUpdate?: boolean;
    categories: ICategory[];
    priceGroupsMap: IVendor_Price_Group_Map[];
    hasPriceGroupMapChange: boolean;
    updateOperationsCompleted: { generalUpdate: boolean; priceGroupMapUpdate: boolean; tokenConfigUpdate: boolean };
    isSaving: boolean;
    shipstationCarriers: IShipstationCarrierDTO[];
    foundVendors: IVendorModel[];
    selectedParentVendor?: IVendorModel | null;
    selectedParentVendorToken?: IConnection_Token | null;
    clearTypeahead: boolean;
    orderCategories: ICategory[];
    shipstationWarehouses: IShipstationWarehouse[];
    shippingZones: IShipping_Zone[];
    shipping_zone_id?: number;
    hide_pricing: boolean;
    pushToQboActive: boolean;
    qboClasses: IQBOClassDTO[];
    qbo_InvoiceClassRef?: string | null;
    qboTaxRates: IQBOTaxRate[];
    notes?: string;
    foundVendorUsers: IUser[];
    selectedAssignedUser?: IUser;
    clearAssignedUserTypeahead: boolean;
    currency_id?: number;
    route_id?: number;
    route?: IRoute;
    resetRouteTypeahead: boolean;
    foundRoutes: IRoute[];
    isLoading: boolean;
    workflowOptions?: IWorkflow[];
    defaultWorkflowId?: number | null;
    qbo_grouped_invoice_type?: QBOGroupedInvoiceTypeEnum | null;
    qbd_skip_sending?: boolean;
    qbd_skip_updating?: boolean;
    foundRepGroups: IRepGroup[];
    selectedRepGroup?: IRepGroup | null;
    clearRepGroupTypeahead: boolean;
    rep_group_id?: number | null;
    tax_shipping?: boolean | null;
    fastboundContacts: IFastBoundContactResult[];
    selectedFbContact: IFastBoundContactResult | null;
    resetFbTypeahead: boolean;
    fastbound_contact_id?: string | null;
    fbSearchField: FastBoundContactSearchField;
    nfa_disposition_type?: FastBoundDispositionTypeEnum | null;
    qboCustomerSearchResults: IQBOCustomerDTO[];
    selectedQboCustomer: IQBOCustomerDTO | null;
};

class VendorSidebar extends Component<Props, State> {
    formEl = React.createRef<HTMLFormElement>();
    sockets: IUiSocketSetup[] = [];

    static defaultProps = {
        cancel: () => {
            console.log("Cancel not implemented.");
        },
        userType: {},
    };

    constructor(props: any) {
        super(props);

        this.state = {
            orderCategories: [],
            clearTypeahead: false,
            pushToQboActive: false,
            selectedParentVendor: null,
            shipstationCarriers: [],
            vendorModel: _.get(this.props, "supplierVendor.Vendor", { active: true } as IVendorModel),
            updateOperationsCompleted: { generalUpdate: true, priceGroupMapUpdate: true, tokenConfigUpdate: true },
            Bill_To: _.get(this.props, "supplierVendor.Vendor.Bill_To", {} as IAddress),
            Ship_To: _.get(this.props, "supplierVendor.Vendor.Ship_To", {} as IAddress),
            qbo_InvoiceClassRef: _.get(this.props.supplierVendor, "Vendor.Vendor_Integration.qbo_InvoiceClassRef", null),
            qbo_SalesTermRef: _.get(this.props.supplierVendor, "Vendor.Vendor_Integration.qbo_SalesTermRef", null),
            qbd_TermOptionListID: _.get(this.props.supplierVendor, "Vendor.Vendor_Integration.qbd_TermOptionListID", null),
            qbd_SalesTaxListID: _.get(this.props.supplierVendor, "Vendor.Vendor_Integration.qbd_SalesTaxListID", null),
            create_in_qbo: _.get(this.props.supplierModel, "Supplier_Integration.has_qbo", false),
            create_in_qbd: _.get(this.props.supplierVendor, "Supplier.Supplier_Integration.has_qbd", false),
            price_discount_one: _.get(this.props.supplierVendor, "price_discount_one"),
            dashboard_order_entry: _.get(this.props.supplierVendor, "dashboard_order_entry"),
            priceGroups: [],
            isOnline: navigator.onLine,
            rebate_groups: [],
            hasTokenConfigUpdate: false,
            categories: [],
            priceGroupsMap: [],
            hasPriceGroupMapChange: false,
            isSaving: false,
            foundVendors: [],
            shipstationWarehouses: [],
            shippingZones: [],
            hide_pricing: _.get(this.props.supplierVendor, "Vendor.hide_pricing", false),
            notes: _.get(this.props.supplierVendor, "Vendor.notes", ""),
            qboClasses: [],
            qboTaxRates: [],
            foundVendorUsers: [],
            clearAssignedUserTypeahead: false,
            currency_id: _.get(this.props.supplierVendor, "Vendor.currency_id"),
            route_id: _.get(this.props.supplierVendor, "Vendor.route_id"),
            route: _.get(this.props.supplierVendor, "Vendor.Route"),
            resetRouteTypeahead: false,
            foundRoutes: [],
            isLoading: !!this.props.supplierVendor,
            defaultWorkflowId: _.get(this.props.supplierVendor, "Vendor.default_workflow_id"),
            qbo_grouped_invoice_type: _.get(this.props.supplierVendor, "Vendor.Vendor_Integration.qbo_grouped_invoice_type", null),
            qbd_skip_sending: _.get(this.props.supplierVendor, "Vendor.Vendor_Integration.qbd_skip_sending", false),
            qbd_skip_updating: _.get(this.props.supplierVendor, "Vendor.Vendor_Integration.qbd_skip_updating", false),
            foundRepGroups: [],
            selectedRepGroup: _.get(this.props.supplierVendor, "Vendor.Rep_Groups[0]", null),
            clearRepGroupTypeahead: false,
            rep_group_id: _.get(this.props.supplierVendor, "Vendor.Rep_Groups[0].id", null),
            tax_shipping: _.get(this.props.supplierVendor, "Vendor.tax_shipping", null),
            fastboundContacts: [],
            selectedFbContact: null,
            resetFbTypeahead: false,
            fastbound_contact_id: _.get(this.props.supplierVendor, "Vendor.Vendor_Integration.fastbound_contact_id", null),
            fbSearchField: "licenseName",
            nfa_disposition_type: _.get(this.props.supplierVendor, "Vendor.Vendor_Integration.nfa_disposition_type", null),
            qboCustomerSearchResults: [],
            selectedQboCustomer: null,
        };

        this.sockets = [
            { endpoint: EndpointsEnum.ShipstationOnGetCarriers, fn: this.onGetShipstationCarriers },
            { endpoint: EndpointsEnum.CategoriesOnGetCategories, fn: this.onGetCategories },
            { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: this.onGetPriceGroups },
            { endpoint: EndpointsEnum.QBOOnGetSalesTerms, fn: this.onQboGetSalesTerms },
            { endpoint: EndpointsEnum.VendorsOnUpdateVendor, fn: this.onUpdateVendor },
            { endpoint: EndpointsEnum.VendorsOnCreateVendor, fn: this.onCreateVendor },
            { endpoint: EndpointsEnum.VendorsOnGetVendor, fn: this.onGetVendor },
            { endpoint: EndpointsEnum.SupplierOnGetRebateGroups, fn: this.onGetRebateGroups },
            { endpoint: EndpointsEnum.VendorsOnGetVendorPriceGroupMap, fn: this.onGetPriceGroupMap },
            { endpoint: EndpointsEnum.VendorsOnUpdateVendorPriceGroupMap, fn: this.onUpdateVendorPriceGroupMap },
            { endpoint: EndpointsEnum.VendorsOnGetVendors, fn: this.onGetVendors },
            { endpoint: EndpointsEnum.TokenOnProcessParentVendorToken, fn: this.onProcessParentVendorToken },
            { endpoint: EndpointsEnum.ShipstationOnListWarehouses, fn: this.onShipstationListWarehouses },
            { endpoint: EndpointsEnum.ShipmentOnGetShippingZones, fn: this.onGetShippingZones },
            { endpoint: EndpointsEnum.QBOOnGetClasses, fn: this.onQboGetClasses },
            { endpoint: EndpointsEnum.QBOOnGetTaxRates, fn: this.onQboGetTaxRates },
            { endpoint: EndpointsEnum.QBOOnPushCustomers, fn: this.onQboPushCustomers },
            { endpoint: EndpointsEnum.RepGroupOnGetRepGroups, fn: this.onLookupRepGroup },
            { endpoint: EndpointsEnum.TokenOnTypeaheadLookupByTokenType, fn: this.onLookupVendorUser },
            { endpoint: EndpointsEnum.TokenOnUpdateTokenConfiguration, fn: this.onUpdateTokenConfiguration },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.RoutesOnGetRoutes, fn: this.onGetRoutes },
            { endpoint: EndpointsEnum.WorkflowsOnGetWorkflows, fn: this.onGetWorkflows },
        ];
    }

    componentDidMount() {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        window.addEventListener("online", this.setOnlineStatus);
        window.addEventListener("offline", this.setOnlineStatus);

        if (this.props.supplierVendor) {
            this.getVendor();
        }

        if (this.props.supplierModel.Supplier_Integration.has_shipstation) {
            this.getShipstationCarriers();
            this.shipstationListWarehouses();
        }

        if (this.props.supplierModel.Supplier_Integration.has_qbo) {
            this.getQboSalesTerms();
            this.getQboClasses();
            this.getQboTaxRates();
        }

        if (this.props.supplierModel.has_rebates && this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN) {
            this.getRebateGroups();
        }

        if (this.props.supplierModel.has_order_categories) {
            this.getOrderCategories();
        }

        if (this.props.supplierModel.has_shipping_by_weight) {
            this.getShippingZones();
        }

        if (this.props.supplierModel.has_multi_workflows) {
            this.getWorkflows();
        }
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }

        window.removeEventListener("online", this.setOnlineStatus);
        window.removeEventListener("offline", this.setOnlineStatus);
    }

    notify = (data: IErrorDTO) => {
        this.setState({
            isSaving: false,
        });
    };

    pushToQbo = () => {
        const payload: IQBOPushCustomersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            accountGuid: this.state.vendorModel.guid,
            onlyUnconnected: false,
        };

        this.props.socket.emit(EndpointsEnum.QBOPushCustomers, payload);

        this.setState({
            pushToQboActive: true,
        });
    };

    onQboPushCustomers = (data: IQBOOnPushCustomersDTO) => {
        const notification: INotification = {
            message: "successfully_pushed_to_quickbooks_online",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.getVendor();

        this.setState({
            pushToQboActive: false,
        });
    };

    getShippingZones = () => {
        const payload: IGetShippingZonesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipmentGetShippingZones, payload);
    };

    onGetShippingZones = (data: IOnGetShippingZonesDTO) => {
        this.setState({
            shippingZones: data.shippingZones,
        });
    };

    setupSidebarForm = () => {
        if (!_.isNil(this.state.vendorModel.lock_catalog_id) && this.state.vendorModel.lock_catalog_id > 0) {
            const catalog = this.getCatalogById(this.state.vendorModel.lock_catalog_id) as ICatalog;

            if (catalog) {
                this.getPriceGroups(catalog.guid);
            }
        }

        if (this.props.supplierVendor) {
            this.getPriceGroupMap();
        }

        this.getVendorCategories();

        const isFormValid = this.getFormValid();

        this.setState({
            isFormValid,
        });
    };

    setOnlineStatus = () => {
        this.setState({
            isOnline: navigator.onLine,
        });
    };

    getVendor = () => {
        if (this.props.supplierVendor?.Vendor) {
            const payload: IGetVendorDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.props.supplierVendor.Vendor.guid,
            };

            this.props.socket.emit(EndpointsEnum.VendorsGetVendor, payload);

            this.setState({
                isLoading: true,
            });
        }
    };

    onGetVendor = (data: IOnGetVendorDTO) => {
        console.log("onGetVendor");

        const tokens = data.vendor.Connection_Tokens;

        let parentVendorToken: IConnection_Token | undefined;
        let parentVendorModel: IVendorModel | undefined;

        if (tokens) {
            for (const token of tokens) {
                if (token.vendor_id === data.vendor.id && token.token_type_id === TokenTypesEnum.VENDOR_VENDOR) {
                    parentVendorToken = token;
                    parentVendorModel = token.Parent_Vendor!;
                    console.log("Found Parent Vendor Token: ", parentVendorModel);
                }
            }
        }

        this.setState(
            {
                selectedParentVendorToken: parentVendorToken,
                selectedParentVendor: parentVendorModel,
                vendorModel: data.vendor,
                route: data.vendor.Route,
                isLoading: false,
            },
            () => {
                this.setupSidebarForm();
            }
        );
    };

    getPriceGroupMap = () => {
        if (!this.props.supplierVendor) {
            return null;
        }

        const payload: IGetVendorPriceGroupMapDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.supplierVendor?.Vendor?.guid,
        };

        this.props.socket.emit(EndpointsEnum.VendorsGetVendorPriceGroupMap, payload);
    };

    onGetPriceGroupMap = (data: IOnGetVendorPriceGroupMapDTO) => {
        this.setState({
            priceGroupsMap: data.vendorMap,
        });
    };

    getShipstationCarriers = () => {
        const payload: IGetShipstationCarriersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationGetCarriers, payload);
    };

    onGetShipstationCarriers = (data: IOnGetShipstationCarriersDTO) => {
        this.setState({
            shipstationCarriers: data.carriers,
        });
    };

    shipstationListWarehouses = () => {
        const payload: IShipstationListWarehousesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationListWarehouses, payload);
    };

    onShipstationListWarehouses = (data: IOnShipstationListWarehousesDTO) => {
        this.setState({
            shipstationWarehouses: data.warehouses,
        });
    };

    getVendorCategories = () => {
        const payload: IGetCategoriesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            isVendorCategory: true,
            onlyRootCategories: true,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
    };

    getOrderCategories = () => {
        const payload: IGetCategoriesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            isOrderCategory: true,
            onlyRootCategories: true,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
    };

    onGetCategories = (data: IOnGetCategoriesDTO) => {
        const state: any = {};

        if (data.isVendorCategory) {
            state.categories = data.categories;
        }

        if (data.isOrderCategory) {
            state.orderCategories = data.categories;
        }

        this.setState(state);
    };

    getRebateGroups = () => {
        const payload: IGetRebateGroupsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.SupplierGetRebateGroups, payload);
    };

    onGetRebateGroups = (data: IOnGetRebateGroupsDTO) => {
        this.setState({
            rebate_groups: data.rebateGroups,
        });
    };

    updateTokenConfiguration = () => {
        if (!this.props.supplierVendor) {
            return null;
        }

        const payload: IUpdateTokenConfigurationDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            tokenGuid: this.props.supplierVendor.guid,
            price_discount_one: this.state.price_discount_one,
            dashboard_order_entry: this.state.dashboard_order_entry,
        };

        this.props.socket.emit(EndpointsEnum.TokenUpdateTokenConfiguration, payload);
    };

    onUpdateTokenConfiguration = (data: IOnUpdateTokenConfigurationDTO) => {
        const opsCompleted = this.state.updateOperationsCompleted;

        opsCompleted.tokenConfigUpdate = true;

        this.setState({ updateOperationsCompleted: opsCompleted }, () => {
            const opsCompleted = this.state.updateOperationsCompleted;

            if (opsCompleted.priceGroupMapUpdate && opsCompleted.tokenConfigUpdate && opsCompleted.generalUpdate) {
                this.showSuccessfulUpdateAndClose();
            }
        });
    };

    onUpdateVendor = (data: IOnUpdateVendorDTO) => {
        const opsCompleted = this.state.updateOperationsCompleted;

        opsCompleted.generalUpdate = true;

        this.setState({ updateOperationsCompleted: opsCompleted }, () => {
            const opsCompleted = this.state.updateOperationsCompleted;

            console.log("opsCompleted: ", opsCompleted);

            if (opsCompleted.priceGroupMapUpdate && opsCompleted.tokenConfigUpdate && opsCompleted.generalUpdate) {
                this.showSuccessfulUpdateAndClose();
            }
        });
    };

    showSuccessfulUpdateAndClose = () => {
        const notification: INotification = {
            title: "successfully_updated",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bl,
        };

        this.props.notifyFn(null, notification, false);

        this.cancel();
    };

    onCreateVendor = (data: any) => {
        const notification: INotification = {
            title: "successfully_created",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bl,
        };

        this.props.notifyFn(null, notification, false);

        this.cancel();
    };

    getQboSalesTerms = () => {
        const payload = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetSalesTerms, payload);
    };

    getQboClasses = () => {
        const payload: IQBOGetClassesDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetClasses, payload);
    };

    onQboGetClasses = (data: IOnQBOGetClassesDTO) => {
        this.setState({ qboClasses: data.classes });
    };

    getQboTaxRates = () => {
        const payload: IQBOGetTaxRatesDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetTaxRates, payload);
    };

    onQboGetTaxRates = (data: IOnQBOGetTaxRatesDTO) => {
        this.setState({ qboTaxRates: data.taxRates });
    };

    onQboGetSalesTerms = (data: IOnQBOGetTermsDTO) => {
        this.setState({ qboSalesTerms: data.termOptions });
    };

    searchQboCustomers = async (name: string) => {
        if (!name || name.length < 2) {
            this.setState({ qboCustomerSearchResults: [] });
            return;
        }

        try {
            const data = await QboService.searchCustomers(name, this.props.userModel, this.props.supplierModel);
            this.setState({ qboCustomerSearchResults: data });
        } catch (err) {
            console.error("QBO customer search failed", err);
        }
    };

    onSelectQboCustomer = (customer: IQBOCustomerDTO) => {
        this.setState({
            selectedQboCustomer: customer,
            qboCustomerSearchResults: [],
        });
    };

    cancel = () => {
        this.props.cancel(false);
    };

    getFormValid = () => {
        let isFormValid = true;

        if (this.formEl && this.formEl.current) {
            const isFormValid = this.formEl.current.checkValidity();
        }

        if (!this.state.vendorModel?.email?.length || !HelperService.validateEmailAddress(this.state.vendorModel.email)) {
            isFormValid = false;
        }

        if (this.state.vendorModel.is_ecomm_user && (!this.state.vendorModel.lock_catalog_id || !this.state.vendorModel.price_group_id)) {
            isFormValid = false;
        }

        return isFormValid;
    };

    handleVendorTokenChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const updatedState = {
            [name]: value,
            // hasTokenConfigUpdate: true,
        };

        // @ts-expect-error
        this.setState(updatedState);
    };

    handleVendorChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const vendorModel = this.state.vendorModel;

        // @ts-expect-error
        vendorModel[name] = value;

        // @ts-expect-error
        const isFormValid = this.getFormValid();

        const updatedState: any = {
            isFormValid,
            vendorModel,
        };

        this.setState(updatedState, () => {
            if (name === "create_in_qbo" && this.state.create_in_qbo) {
                this.getQboSalesTerms();
            }
        });
    };

    updateShipTo = (address: IAddress | INewAddress) => {
        this.setState({
            Ship_To: address as IAddress,
        });
    };

    updateBillTo = (address: IAddress | INewAddress) => {
        this.setState({
            Bill_To: address as IAddress,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        // @ts-expect-error
        const isFormValid = this.getFormValid();

        const updatedState: any = {
            isFormValid,
        };

        // Handle the Bill To or Ship To Address Blocks
        if (name.indexOf(".") > 0) {
            const addressType = name.substr(0, 7);
            const section = name.substr(8, name.length);

            const existingSection = _.get(this.state, `${addressType}`, {});

            updatedState[addressType] = existingSection;

            if (name.indexOf("state") !== -1) {
                value = value.trim();
            }

            updatedState[addressType][section] = value;
        } else {
            updatedState[name] = value;
        }

        this.setState(updatedState, () => {
            if (name === "create_in_qbo" && this.state.create_in_qbo) {
                this.getQboSalesTerms();
            }
        });
    };

    getParentVendorTokenDetail = () => {
        const token: { parent_vendor_id?: number; guid?: string } = {};

        if (this.state.selectedParentVendor) {
            token.parent_vendor_id = this.state.selectedParentVendor.id;
        }

        if (this.state.selectedParentVendorToken && this.state.selectedParentVendor) {
            token.guid = this.state.selectedParentVendorToken.guid;
        }

        return token;
    };

    processSelectedParentVendor = () => {
        // get an existing token details.

        if (this.props.supplierVendor) {
            const payload: IProcessParentVendorTokenDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.props.supplierVendor.Vendor!.guid,
                token: {},
            };

            if (this.state.selectedParentVendor) {
                payload.token.parent_vendor_id = this.state.selectedParentVendor.id;
            }

            if (this.state.selectedParentVendorToken && this.state.selectedParentVendor) {
                // @ts-expect-error
                payload.token.guid = this.state.selectedParentVendorToken.guid;
            } else {
                if (this.state.selectedParentVendorToken) {
                    payload.deleteFlag = true;
                }
            }

            this.props.socket.emit(EndpointsEnum.TokenProcessParentVendorToken, payload);
        }
    };

    onProcessParentVendorToken = (data: IOnProcessParentVendorTokenDTO) => {
        const notification: INotification = {
            message: "successfully_processed_parent_relationship",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);
    };

    doFastBoundContactLookup = async (value: string) => {
        const fastboundAccountId = this.state.vendorModel.Vendor_Integration?.fastbound_account_id;
        if (!fastboundAccountId) return;
        try {
            const results = await FastBoundService.searchContacts(
                value,
                fastboundAccountId,
                this.props.userModel,
                this.props.supplierModel,
                this.state.fbSearchField
            );
            this.setState({ fastboundContacts: results });
        } catch {
            this.setState({ fastboundContacts: [] });
        }
    };

    handleFastBoundContactSelect = (selected: IFastBoundContactResult | null) => {
        this.setState({
            fastbound_contact_id: selected?.id || null,
            selectedFbContact: selected,
        });
    };

    saveVendor = () => {
        const qboSalesTerm = _.find(this.state.qboSalesTerms, (term) => {
            if (term) {
                return term.Id === this.state.qbo_SalesTermRef;
            } else {
                return false;
            }
        });

        const payload: IUpdateVendorDTO | ICreateVendorDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,

            options: {
                active: !!this.state.vendorModel.active,
                lock_catalog_id: this.state.vendorModel.lock_catalog_id,
                price_group_id: this.state.vendorModel.price_group_id,
                payment_type_id: this.state.vendorModel.payment_type_id,
                payment_type_name: this.state.vendorModel.payment_type_name,
                resale_tax_id: this.state.vendorModel.resale_tax_id,
                ffl_number: this.state.vendorModel.ffl_number,
                create_in_qbo: this.state.create_in_qbo,
                create_in_qbd: this.state.create_in_qbd,
                termId: qboSalesTerm ? qboSalesTerm.Id : undefined,
                termName: qboSalesTerm ? qboSalesTerm.Name : undefined,
                qbo_InvoiceClassRef: this.state.qbo_InvoiceClassRef ? this.state.qbo_InvoiceClassRef : undefined,
                qbo_SalesTermRef: qboSalesTerm ? qboSalesTerm.Id : undefined,
                qbd_TermOptionListID: this.state.qbd_TermOptionListID,
                qbd_SalesTaxListID: this.state.qbd_SalesTaxListID,
                is_sample_account: this.state.vendorModel.is_sample_account,
                has_order_bonus: this.state.vendorModel.has_order_bonus,
                order_bonus_perc: this.state.vendorModel.order_bonus_perc,
                rebate_group_id: this.state.vendorModel.rebate_group_id,
                category_id: this.state.vendorModel.category_id,
                require_confirm_ship_to: this.state.vendorModel.require_confirm_ship_to,
                require_payment: this.state.vendorModel.require_payment,
                priority: this.state.vendorModel.priority,
                default_shipping_instructions: this.state.vendorModel.default_shipping_instructions,
                default_order_category_id: this.state.vendorModel.default_order_category_id,
                customer_internal_id: this.state.vendorModel.customer_internal_id,
                taxjar_exemption_type: this.state.vendorModel.taxjar_exemption_type,
                shipping_email: this.state.vendorModel.shipping_email,
                shipping_zone_id: this.state.shipping_zone_id,
                tax_exempt: !!this.state.vendorModel.tax_exempt,
                require_po: this.state.vendorModel.require_po,
                hide_pricing: this.state.hide_pricing,
                commission_rate: this.state.vendorModel.commission_rate,
                is_ecomm_user: this.state.vendorModel.is_ecomm_user,
                net_term_ecomm_user: this.state.vendorModel.net_term_ecomm_user,
                ecomm_template_items_only: this.state.vendorModel.ecomm_template_items_only,
                notes: this.state.vendorModel.notes,
                freight_policy: this.state.vendorModel.freight_policy,
                credit_limit: this.state.vendorModel.credit_limit,
                default_local_pickup: this.state.vendorModel.default_local_pickup,
                default_local_delivery: this.state.vendorModel.default_local_delivery,
                currency_id: this.state.currency_id,
                route_id: this.state.route_id,
                default_workflow_id: this.state.defaultWorkflowId,
                qbo_grouped_invoice_type: this.state.qbo_grouped_invoice_type,
                qbd_skip_sending: this.state.qbd_skip_sending,
                qbd_skip_updating: this.state.qbd_skip_updating,
                rep_group_id: this.state.rep_group_id,
                tax_shipping: this.state.tax_shipping,
                fastbound_contact_id: this.state.fastbound_contact_id,
                nfa_disposition_type: this.state.nfa_disposition_type,
                qbo_CustomerId: this.state.selectedQboCustomer?.Id || undefined,
                timezone: this.state.vendorModel.timezone,
            },
            tokenOptions: {
                price_discount_one: this.state.price_discount_one,
                dashboard_order_entry: this.state.dashboard_order_entry,
            },

            billTo: this.state.Bill_To,
            shipTo: this.state.Ship_To,
            name: this.state.vendorModel.name,
            email: this.state.vendorModel.email,
            shippingDetails: this.state.vendorModel.Shipping_Details || [],
            shippingAccounts: this.state.vendorModel.Shipping_Accounts || [],
        };

        console.log("payload.options", payload.options);

        if (this.state.selectedAssignedUser && payload.options) {
            payload.options.order_assigned_user_id = this.state.selectedAssignedUser.id;
        }

        const updateOperationsCompleted = this.state.updateOperationsCompleted;
        updateOperationsCompleted.generalUpdate = false;

        if (this.state.hasTokenConfigUpdate) {
            updateOperationsCompleted.tokenConfigUpdate = false;
        }

        if (this.state.hasPriceGroupMapChange) {
            updateOperationsCompleted.priceGroupMapUpdate = false;
        }

        if (!_.isNil(this.props.supplierVendor) && this.props.supplierVendor.Vendor) {
            // @ts-expect-error
            payload.tokenGuid = this.props.supplierVendor.guid;
            // @ts-expect-error
            payload.vendorGuid = this.props.supplierVendor.Vendor.guid;

            if (this.state.selectedParentVendorToken || this.state.selectedParentVendor) {
                this.processSelectedParentVendor();
            }

            this.props.socket.emit(EndpointsEnum.VendorsUpdateVendor, payload);
        } else {
            if (this.state.selectedParentVendorToken || this.state.selectedParentVendor) {
                // @ts-expect-error
                payload.parentVendorToken = this.getParentVendorTokenDetail();
            }

            this.props.socket.emit(EndpointsEnum.VendorsCreateVendor, payload);
        }

        if (this.state.hasPriceGroupMapChange) {
            const priceGroupPayload: IUpdateVendorPriceGroupMapDTO = {
                vendorGuid: this.props.supplierVendor!.Vendor!.guid,
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorMap: this.state.priceGroupsMap,
            };

            this.props.socket.emit(EndpointsEnum.VendorsUpdateVendorPriceGroupMap, priceGroupPayload);
        }

        if (this.state.hasTokenConfigUpdate) {
            this.updateTokenConfiguration();
        }

        this.setState({
            updateOperationsCompleted,
            isSaving: true,
        });
    };

    onUpdateVendorPriceGroupMap = (data: IOnUpdateVendorPriceGroupMapDTO) => {
        const opsCompleted = this.state.updateOperationsCompleted;

        opsCompleted.priceGroupMapUpdate = true;

        this.setState({ updateOperationsCompleted: opsCompleted }, () => {
            const opsCompleted = this.state.updateOperationsCompleted;

            if (opsCompleted.priceGroupMapUpdate && opsCompleted.tokenConfigUpdate && opsCompleted.generalUpdate) {
                this.showSuccessfulUpdateAndClose();
            }
        });
    };

    lockCatalog = (e: ChangeEvent<any>) => {
        this.handleVendorChange(e);

        const catalog_id = parseInt(e.target.value);

        const catalog = this.getCatalogById(catalog_id) as ICatalog;

        if (!_.isNil(catalog)) {
            this.getPriceGroups(catalog.guid);
        }
    };

    getCatalogById = (catalog_id: number) => {
        if (!_.isNumber(catalog_id)) {
            catalog_id = parseInt(catalog_id);
        }

        const catalog = _.find(this.props.catalogs, (catalog) => {
            if (catalog.id === catalog_id) {
                return true;
            }
        });

        return catalog;
    };

    onGetPriceGroups = (data: any) => {
        const state: any = {
            priceGroups: data.priceGroups,
        };

        this.setState(state);
    };

    getPriceGroups = (catalogGuid: string) => {
        const payload = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
    };

    copyShipToBillTo = () => {
        this.setState({
            Bill_To: { ...this.state.Ship_To },
        });
    };

    copyBillToShipTo = () => {
        this.setState({
            Ship_To: { ...this.state.Bill_To },
        });
    };

    handlePriceGroupAdjustment = (e: ChangeEvent<any>, id: number) => {
        const priceGroupsMap = this.state.priceGroupsMap;

        for (const priceGroupMap of priceGroupsMap) {
            if (priceGroupMap.price_group_id === id) {
                priceGroupMap.price_adjustment = Number(e.target.value);
            }
        }

        this.setState({
            priceGroupsMap,
            hasPriceGroupMapChange: true,
        });
    };

    handlePriceGroupAdjustmentExp = (moment: Moment, id: number) => {
        const priceGroupsMap = this.state.priceGroupsMap;

        for (const priceGroupMap of priceGroupsMap) {
            if (priceGroupMap.price_group_id === id) {
                priceGroupMap.price_adjustment_expiration = moment.format("YYYY-MM-DD");
            }
        }

        this.setState({
            priceGroupsMap,
            hasPriceGroupMapChange: true,
        });
    };

    updateShippingAccounts = (shippingAccounts: IShipping_AccountUI | INewShipping_Account[]) => {
        const vendorModel = this.state.vendorModel;

        // @ts-expect-error
        vendorModel.Shipping_Accounts = shippingAccounts;

        this.setState({
            vendorModel,
        });
    };

    updateShippingDetails = (shippingDetails: IShipping_DetailUI[] | INewShipping_Detail[]) => {
        const vendorModel = this.state.vendorModel;

        // @ts-expect-error
        vendorModel.Shipping_Details = shippingDetails;

        this.setState({
            vendorModel,
        });
    };

    getVendors = (name: string) => {
        const payload: IGetVendorsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            queryString: `?name=${name}`,
        };

        this.props.socket.emit(EndpointsEnum.VendorsGetVendors, payload);
    };

    onGetVendors = (data: IOnGetVendorsDTO) => {
        const foundVendors = data.supplierVendorTokens.map((token) => {
            return token.Vendor!;
        });

        this.setState({
            foundVendors,
        });
    };

    selectParentVendor = (vendor: IVendorModel) => {
        this.setState({
            selectedParentVendor: vendor,
        });
    };

    clearTypeahead = () => {
        this.setState({
            selectedParentVendor: null,
            clearTypeahead: false,
        });
    };

    lookupVendorUser = (str: string) => {
        if (this.state.vendorModel) {
            const payload: ITypeaheadLookupByTokenTypeDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.state.vendorModel.guid,
                tokenType: "ALL_USERS",
                name: str,
            };

            this.props.socket.emit(EndpointsEnum.TokenTypeaheadLookupByTokenType, payload);
        }
    };

    onLookupVendorUser = (data: IOnTypeaheadLookupByTokenTypeDTO) => {
        const foundVendorUsers = data.results.map((result) => {
            return result.User!;
        });

        this.setState({
            foundVendorUsers,
        });
    };

    addAssignedUser = (user: IUser) => {
        this.setState({
            selectedAssignedUser: user,
        });
    };

    removeAssignedUser = (user: IUser, index: number) => {
        // const assignedUsers = this.state.assignedUsers;
        //
        // assignedUsers.splice(index, 1);
        //
        // this.setState({
        //     assignedUsers,
        // });
    };

    clearSelectedAssignedUser = () => {
        // this.setState({
        //     clearAssignedUserTypeahead: false,
        //     selectedAssignedUser: null,
        // });
    };

    lookupRoute = (name: string) => {
        const payload: IGetRoutesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
        };

        this.props.socket.emit(EndpointsEnum.RoutesGetRoutes, payload);
    };

    onGetRoutes = (data: IOnGetRoutesDTO) => {
        this.setState({
            foundRoutes: data.routes,
        });
    };

    getWorkflows = () => {
        const payload: IGetWorkflowsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.WorkflowsGetWorkflows, payload);
    };

    onGetWorkflows = (data: IOnGetWorkflowsDTO) => {
        this.setState({
            workflowOptions: data.workflows,
        });
    };

    selectRoute = (route: IRoute) => {
        this.setState({
            route_id: route.id,
            route,
        });
    };

    resetRouteTypeaheadFn = () => {
        this.setState({
            resetRouteTypeahead: false,
        });
    };

    clearRouteSelection = () => {
        this.setState({
            route_id: undefined,
            route: undefined,
            resetRouteTypeahead: true,
        });
    };

    lookupRepGroup = (name: string) => {
        const payload: IGetRepGroupsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
        };

        this.props.socket.emit(EndpointsEnum.RepGroupGetRepGroups, payload);
    };

    onLookupRepGroup = (data: IOnGetRepGroupsDTO) => {
        this.setState({
            foundRepGroups: data.repGroups,
        });
    };

    selectRepGroup = (repGroup: IRepGroup) => {
        this.setState({
            selectedRepGroup: repGroup,
            rep_group_id: repGroup.id,
        });
    };

    clearRepGroupSelection = () => {
        this.setState({
            selectedRepGroup: null,
            rep_group_id: null,
            clearRepGroupTypeahead: true,
        });
    };

    resetRepGroupTypeaheadFn = () => {
        this.setState({
            clearRepGroupTypeahead: false,
        });
    };

    render() {
        let header = "create_vendor";

        if (this.props.supplierVendor && this.props.supplierVendor.guid) {
            header = "update_vendor";
        }

        const catalogs = _.get(this.props, "catalogs", []);

        let priceGroups;

        if (catalogs.length === 1) {
            priceGroups = _.sortBy(catalogs[0].Price_Groups, ["value"]);
        } else {
            // TODO add logic for multiple catalogs
            priceGroups = _.sortBy(this.state.priceGroups, ["value"]);
        }

        let hidePricingOption: any = null;

        if (this.props.supplierModel && this.props.supplierModel.has_hide_pricing) {
            hidePricingOption = (
                <div className={"mt-2"}>
                    <OwToggle
                        fn={this.handleChange}
                        name={"hide_pricing"}
                        label={"hide_pricing"}
                        active={!!this.state.hide_pricing}
                        labelOnRight={true}
                    />
                </div>
            );
        }

        const isMasterUser = _.get(this.props, "supplierVendor.is_master", false);

        const userType = this.props.userModel.userType || ({} as IUser_Type);

        let showCatalogSelection = false;

        if (userType.id === UserTypesEnum.ADMIN) {
            showCatalogSelection = true;
        } else {
            if (this.props.userModel.supplierUserToken?.access_type_id === AccessTypesEnum.FULL) {
                showCatalogSelection = true;
            }

            if (this.props.userModel.supplierUserToken?.is_sales_rep && this.props.supplierModel.allow_sales_reps_create_accounts) {
                // only show it if they're not assigned to a specific price group
                if (!this.props.userModel.supplierUserToken?.price_group_id) {
                    showCatalogSelection = true;
                }
            }
        }

        const paymentTypeKeys = Object.keys(SystemConst.paymentTypes);
        const paymentTypes: any[] = [];

        for (const key of paymentTypeKeys) {
            const option: any = {
                // @ts-expect-error
                value: SystemConst.paymentTypes[key],
                label: key.toLowerCase(),
            };

            paymentTypes.push(option);
        }

        let allowQuickBooksCreate = false;

        if (this.props.supplierVendor && this.props.supplierVendor.guid) {
            allowQuickBooksCreate = false;
        } else {
            if (this.props.supplierModel.Supplier_Integration.has_qbo) {
                allowQuickBooksCreate = true;
            }
        }

        let allowQuickBooksDesktopCreate = false;

        if (this.props.supplierVendor && this.props.supplierVendor.guid) {
            allowQuickBooksDesktopCreate = false;
        } else {
            if (this.props.supplierModel.Supplier_Integration.has_qbd) {
                if (this.props.userModel.supplierUserToken?.User_Type?.name === "ADMIN") {
                    allowQuickBooksDesktopCreate = true;
                }
            }
        }

        let allowSquareCreate = false;

        if (this.props.supplierModel.Supplier_Integration.has_square) {
            allowSquareCreate = true;
        }

        let resaleTaxDocUploader: any = null;
        let creditCardAuthDocUploader: any = null;
        let stateDocumentUploader: any = null;

        let hasOrderBonus = false;

        if (this.props.supplierModel.has_order_bonus) {
            hasOrderBonus = true;
        }

        let hasConfirmShipTo = false;

        if (this.props.supplierModel.has_confirm_ship_to) {
            hasConfirmShipTo = true;
        }

        if (this.props.supplierVendor && this.props.supplierVendor.Vendor && this.props.userModel && this.props.supplierModel) {
            resaleTaxDocUploader = (
                <div className={"mt-4"}>
                    <OwLabel title={"resale_tax_document"} />
                    <OwS3Uploader
                        socket={this.props.socket}
                        userModel={this.props.userModel!}
                        supplierModel={this.props.supplierModel}
                        isReadOnly={false}
                        resourceType={FileUploadResourceTypeEnum.vendorResaleTaxDoc}
                        vendorModel={this.props.supplierVendor.Vendor}
                    />
                </div>
            );

            if (
                this.props.supplierVendor &&
                this.props.supplierVendor.Vendor &&
                this.props.userModel &&
                this.props.supplierModel &&
                this.props.supplierModel.has_account_state_license
            ) {
                stateDocumentUploader = (
                    <div className={"mt-4"}>
                        <OwLabel title={"state_license_document"} />
                        <OwS3Uploader
                            socket={this.props.socket}
                            userModel={this.props.userModel!}
                            supplierModel={this.props.supplierModel}
                            isReadOnly={false}
                            resourceType={FileUploadResourceTypeEnum.vendorStateLicense}
                            vendorModel={this.props.supplierVendor.Vendor}
                        />
                        {this.state.vendorModel?.State_License_Attachment ? (
                            <OwS3DownloadLink attachment={this.state.vendorModel.State_License_Attachment} />
                        ) : null}
                    </div>
                );
            }

            if (Number(this.state.vendorModel.payment_type_id) === PaymentTypeEnum.CREDIT_CARD) {
                creditCardAuthDocUploader = (
                    <div>
                        <div>
                            <OwLabel title={"credit_card_auth_form"} />
                            <OwS3Uploader
                                socket={this.props.socket}
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                isReadOnly={false}
                                resourceType={FileUploadResourceTypeEnum.vendorCreditCardAuthDoc}
                                vendorModel={this.props.supplierVendor.Vendor}
                            />
                        </div>
                    </div>
                );
            }
        }

        let qbd_TermOptions: {
            ListID: string;
            Name: string;
            IsActive: QBDBooleanStringEnum;
            StdDueDays: string;
            StdDiscountDays: string;
        }[] = [];

        if (_.isArray(this.props.supplierModel.Supplier_Integration.qbd_TermOptions)) {
            qbd_TermOptions = this.props.supplierModel.Supplier_Integration.qbd_TermOptions;
        } else {
            if (_.isString(this.props.supplierModel.Supplier_Integration.qbd_TermOptions)) {
                qbd_TermOptions = JSON.parse(this.props.supplierModel.Supplier_Integration.qbd_TermOptions);
            }
        }

        const taxJarExemptionOptions = [
            { value: TaxJarExemptionTypeEnum.WHOLESALE },
            { value: TaxJarExemptionTypeEnum.GOVERNMENT },
            { value: TaxJarExemptionTypeEnum.MARKETPLACE },
            { value: TaxJarExemptionTypeEnum.NON_EXEMPT },
            { value: TaxJarExemptionTypeEnum.OTHER },
        ];

        let taxJarLogoSrc = taxJarLogo;

        if (UIService.isMainViewLight()) {
            taxJarLogoSrc = taxJarLightLogo;
        }

        const isValidEmail = HelperService.validateEmailAddress(this.state.vendorModel.email || "");

        return (
            <div className="VendorSidebar position-relative">
                {this.state.isLoading ? (
                    <LoadingOverlay>
                        <OwLabel title={"loading"} leftIconClass={"fas fa-rotate fa-spin"} />
                    </LoadingOverlay>
                ) : null}
                <div className={"p-2"}>
                    <div className={"d-flex justify-content-between border-bottom mb-2 flex-shrink-0"}>
                        <div>
                            <OwTitle
                                className={"mb-2"}
                                leftIconName={"fas fa-user"}
                                title={header}
                                isSupplierVendorOverride={true}
                                supplierModel={this.props.supplierModel}
                            />
                            {this.state.vendorModel.name}
                        </div>
                        <div className="text-end">
                            <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                                <i className="far fa-times" />
                            </button>
                        </div>
                    </div>

                    <div className={"pb-4 pe-2 formContent"}>
                        <form ref={this.formEl}>
                            <div className={"bd-callout"}>
                                <OwLabel title={"details"} />
                            </div>
                            <div className={"mb-2"}>
                                <OwLabel title={"name"} showIsReqAsterik={true} />
                                <OwInputWrapper
                                    placeholder={"name"}
                                    name={"name"}
                                    value={this.state.vendorModel.name}
                                    fn={this.handleVendorChange}
                                    isRequired={true}
                                />
                            </div>

                            <div className={"mb-2"}>
                                <div>
                                    <OwLabel title={"email_remit_to"} showIsReqAsterik={true} />
                                    {isValidEmail ? null : <OwLabel className={"text-danger ms-2"} title={"invalid_email"} />}
                                </div>
                                <OwInputWrapper
                                    placeholder={"email"}
                                    name={"email"}
                                    value={this.state.vendorModel.email}
                                    fn={this.handleVendorChange}
                                    isRequired={true}
                                    className={isValidEmail ? "bg-success-subtle" : "bg-danger-subtle"}
                                />
                            </div>

                            <div className={"mb-2"}>
                                <OwToggle
                                    fn={this.handleVendorChange}
                                    name={"active"}
                                    label={"active"}
                                    active={!!this.state.vendorModel.active}
                                    labelOnRight={true}
                                />
                            </div>

                            <div className={"mb-2"}>
                                <OwToggle
                                    fn={this.handleVendorChange}
                                    name={"is_sample_account"}
                                    label={"is_sample_account"}
                                    active={!!this.state.vendorModel.is_sample_account}
                                    labelOnRight={true}
                                />
                            </div>

                            <div className={"mb-2"}>
                                <OwToggle
                                    fn={this.handleVendorTokenChange}
                                    name={"dashboard_order_entry"}
                                    label={"dashboard_order_entry"}
                                    active={!!this.state.dashboard_order_entry}
                                    labelOnRight={true}
                                />
                            </div>

                            {this.props.supplierModel.has_rep_groups ? (
                                <div className={"mb-2"}>
                                    <OwLabel title={"rep_group"} />
                                    <TypeaheadFn
                                        lookupFn={this.lookupRepGroup}
                                        availableOptions={this.state.foundRepGroups}
                                        selectedOptionFn={this.selectRepGroup}
                                        selectedOption={this.state.selectedRepGroup}
                                        resetTypeahead={this.state.clearRepGroupTypeahead}
                                        resetTypeaheadCallbackFn={this.resetRepGroupTypeaheadFn}
                                        titleProp={"name"}
                                        valueProp={"id"}
                                        emitSelectionSetup={{ emitObject: true }}
                                        clearSelectionFn={this.clearRepGroupSelection}
                                    />
                                </div>
                            ) : null}

                            {this.props.supplierModel.has_routes ? (
                                <div className={"mb-2"}>
                                    <div>
                                        <OwLabel title={"route"} />
                                    </div>
                                    <div>
                                        <TypeaheadFn
                                            lookupFn={this.lookupRoute}
                                            availableOptions={this.state.foundRoutes}
                                            selectedOptionFn={this.selectRoute}
                                            selectedOption={this.state.route}
                                            resetTypeahead={this.state.resetRouteTypeahead}
                                            resetTypeaheadCallbackFn={this.resetRouteTypeaheadFn}
                                            titleProp={"name"}
                                            valueProp={"id"}
                                            emitSelectionSetup={{ emitObject: true }}
                                            clearSelectionFn={this.clearRouteSelection}
                                        />
                                    </div>
                                </div>
                            ) : null}

                            <div className={"mb-2"}>
                                <div>
                                    <OwLabel
                                        title={"parent_vendor"}
                                        supplierModel={this.props.supplierModel}
                                        isSupplierVendorOverride={true}
                                    />
                                </div>
                                <div>
                                    <Typeahead
                                        isSelectableFn={() => {
                                            return true;
                                        }}
                                        typeaheadApiFn={this.getVendors}
                                        titleProp={"name"}
                                        subTitleProp={"email"}
                                        typeaheadItems={this.state.foundVendors}
                                        selectedItemFn={this.selectParentVendor}
                                        selectedItem={this.state.selectedParentVendor}
                                        selectedItemTitleProp={"name"}
                                        clearTypeaheadCallback={this.clearTypeahead}
                                        clearTypeahead={this.state.clearTypeahead}
                                    />
                                </div>
                            </div>
                            {this.props.supplierModel.has_multi_workflows ? (
                                <div className={"mb-2"}>
                                    <div>
                                        <OwLabel title={"default_workflow"} />
                                    </div>
                                    <div>
                                        <OwSelectOption
                                            name={"defaultWorkflowId"}
                                            options={this.state.workflowOptions}
                                            titleProp={"name"}
                                            valueProp={"id"}
                                            selectedOption={this.state}
                                            selectedOptionProp={"defaultWorkflowId"}
                                            fn={this.handleChange}
                                        />
                                    </div>
                                </div>
                            ) : null}

                            <div className={"mb-2"}>
                                <div>
                                    <OwLabel title={"default_assigned_user"} />
                                </div>
                                <div>
                                    <Typeahead
                                        outerWrapperClassName={""}
                                        isSelectableFn={() => {
                                            return true;
                                        }}
                                        scrollableList={true}
                                        typeaheadApiFn={this.lookupVendorUser}
                                        confirmAdd={true}
                                        selectedItemFn={this.addAssignedUser}
                                        selectedItem={this.state.selectedAssignedUser}
                                        typeaheadItems={this.state.foundVendorUsers}
                                        selectedItemTitleProp={"name"}
                                        titleProp={"name"}
                                        subTitleProp={"email"}
                                        clearTypeahead={this.state.clearAssignedUserTypeahead}
                                        clearTypeaheadCallback={this.clearSelectedAssignedUser}
                                        sideFilter={false}
                                    />
                                </div>
                                <div>
                                    {this.state.selectedAssignedUser ? (
                                        <div>
                                            <div>{this.state.selectedAssignedUser.name}</div>
                                            <div className={"text-muted"}>{this.state.selectedAssignedUser.email}</div>
                                        </div>
                                    ) : null}
                                </div>
                                <div>
                                    {this.state.vendorModel.Order_Assigned_User ? (
                                        <div>
                                            <div>{this.state.vendorModel.Order_Assigned_User.name}</div>
                                            <div className={"text-muted"}>{this.state.vendorModel.Order_Assigned_User.email}</div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>

                            <div className={"mb-2"}>
                                <OwLabel title={"customer_internal_id"} />
                                <OwInputWrapper
                                    placeholder={"customer_internal_id"}
                                    name={"customer_internal_id"}
                                    value={this.state.vendorModel.customer_internal_id}
                                    fn={this.handleVendorChange}
                                />
                            </div>

                            <div className={"mb-2"}>
                                <OwLabel title={"note"} />
                                <OwTextArea name={"notes"} fn={this.handleVendorChange} value={this.state.vendorModel.notes} />
                            </div>

                            <div className={"mb-2"}>
                                <OwLabel title={"freight_policy"} />
                                <OwTextArea
                                    name={"freight_policy"}
                                    fn={this.handleVendorChange}
                                    value={this.state.vendorModel.freight_policy}
                                />
                            </div>

                            {this.props.supplierModel.has_sales_tax && (
                                <div className={"mb-2"}>
                                    <OwToggle
                                        fn={this.handleChange}
                                        name={"tax_shipping"}
                                        label={"tax_shipping"}
                                        active={!!this.state.tax_shipping}
                                        labelOnRight={true}
                                    />
                                </div>
                            )}

                            <div className={"mb-2"}>
                                <OwLabel title={"shipping_email"} />
                                <OwInputWrapper
                                    placeholder={"shipping_email"}
                                    name={"shipping_email"}
                                    value={this.state.vendorModel.shipping_email}
                                    fn={this.handleVendorChange}
                                />
                            </div>

                            {this.props.supplierModel.has_currencies ? (
                                <CurrencySelect updateCurrencyId={this.handleChange} selectedCurrencyId={this.state.currency_id} />
                            ) : null}

                            <div>
                                <div className={"mb-2 mt-2"}>
                                    <div className={"bd-callout d-flex justify-content-center align-items-center"}>
                                        <OwLabel title={"ship_to"} />
                                        <div className={"ms-auto"}>
                                            <OwButton className={"btn-primary"} title={"copy_bill_to"} fn={this.copyBillToShipTo} />
                                        </div>
                                    </div>
                                </div>

                                <AddressBlock
                                    address={this.state.Ship_To}
                                    showName={true}
                                    showCompanyName={true}
                                    showPhoneFax={true}
                                    showInternalId={true}
                                    prefix={"Ship_To."}
                                    fn={this.handleChange}
                                    updateEntireAddressFn={this.updateShipTo}
                                />
                            </div>

                            <div>
                                <div className={"mb-2 mt-2"}>
                                    <div className={"bd-callout d-flex justify-content-center align-items-center"}>
                                        <OwLabel title={"bill_to"} />
                                        <div className={"ms-auto"}>
                                            <OwButton className={"btn-primary"} title={"copy_ship_to"} fn={this.copyShipToBillTo} />
                                        </div>
                                    </div>
                                </div>
                                <AddressBlock
                                    address={this.state.Bill_To}
                                    showName={true}
                                    showCompanyName={true}
                                    showPhoneFax={true}
                                    showInternalId={true}
                                    prefix={"Bill_To."}
                                    fn={this.handleChange}
                                    updateEntireAddressFn={this.updateBillTo}
                                />
                            </div>

                            <div className={"bd-callout"}>
                                <OwLabel title={"resale_details"} />
                            </div>

                            <div>
                                <OwLabel title={"resale_tax_id"} />
                                <OwInputWrapper
                                    className={"form-control-sm"}
                                    value={this.state.vendorModel.resale_tax_id}
                                    name={"resale_tax_id"}
                                    fn={this.handleVendorChange}
                                />
                                {this.props.supplierModel.Supplier_Integration.has_qbo ? (
                                    <div className={"text-warning"}>
                                        <i className={"fas fa-triangle-exclamation me-2"} />
                                        <OwTranslate id={"max_n_characters"} defaultMessage={"max_16_characters"} values={{ n: 16 }} />
                                    </div>
                                ) : null}
                            </div>

                            {resaleTaxDocUploader}

                            {stateDocumentUploader}

                            {this.props.supplierModel.Industries?.some((i) => i.name === IndustryNameEnum.Firearms) && (
                                <div className={"mt-4 mb-2"}>
                                    <OwLabel title={"ffl_number"} />
                                    <OwInputWrapper
                                        className={"form-control-sm"}
                                        value={this.state.vendorModel.ffl_number}
                                        name={"ffl_number"}
                                        fn={this.handleVendorChange}
                                    />
                                </div>
                            )}

                            {!!this.state.vendorModel.Vendor_Integration?.fastbound_account_id && (
                                <div className={"mt-4 mb-2"}>
                                    <OwLabel title={"fastbound_contact"} />
                                    {this.state.fastbound_contact_id ? (
                                        <div className="d-flex align-items-center gap-2">
                                            <i className="fas fa-check-circle text-success" />
                                            <span>
                                                {this.state.selectedFbContact
                                                    ? getFbContactDisplayName(this.state.selectedFbContact)
                                                    : "Linked"}
                                                {this.state.selectedFbContact && getFbContactLocation(this.state.selectedFbContact) && (
                                                    <span className="text-muted ms-1">
                                                        ({getFbContactLocation(this.state.selectedFbContact)})
                                                    </span>
                                                )}
                                            </span>
                                            <OwButton
                                                fn={() => this.handleFastBoundContactSelect(null)}
                                                centerIconClass={"fas fa-times"}
                                                className={"btn-outline-danger btn-sm"}
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            <div className="d-flex gap-2 mb-1">
                                                <select
                                                    className="form-select form-select-sm"
                                                    style={{ maxWidth: "10rem" }}
                                                    value={this.state.fbSearchField}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            fbSearchField: e.target.value as FastBoundContactSearchField,
                                                            fastboundContacts: [],
                                                        })
                                                    }>
                                                    {fbContactSearchFields.map((f) => (
                                                        <option key={f.value} value={f.value}>
                                                            {f.title}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <TypeaheadFn
                                                lookupFn={this.doFastBoundContactLookup}
                                                availableOptions={this.state.fastboundContacts}
                                                selectedOptionFn={this.handleFastBoundContactSelect}
                                                valueProp="id"
                                                placeholder="Search FastBound contacts..."
                                                emitSelectionSetup={{ emitObject: true }}
                                                resetTypeahead={this.state.resetFbTypeahead}
                                                resetTypeaheadCallbackFn={() => this.setState({ resetFbTypeahead: false })}
                                                clearSelectionFn={() => this.handleFastBoundContactSelect(null)}
                                                isScrollable={true}
                                                maxHeight={200}
                                                renderFn={(item: IFastBoundContactResult) => (
                                                    <div>
                                                        <div>{getFbContactDisplayName(item)}</div>
                                                        {getFbContactLocation(item) && (
                                                            <div className="text-muted small">{getFbContactLocation(item)}</div>
                                                        )}
                                                    </div>
                                                )}
                                            />
                                        </>
                                    )}
                                </div>
                            )}

                            {!!this.state.fastbound_contact_id && (
                                <div className={"mt-2 mb-2"}>
                                    <OwLabel title={"nfa_disposition_type"} />
                                    <OwSelectOption
                                        options={Object.values(FastBoundDispositionTypeEnum).map((v) => ({ value: v, title: v }))}
                                        valueProp={"value"}
                                        titleProp={"title"}
                                        name={"nfa_disposition_type"}
                                        selectedOption={this.state}
                                        selectedOptionProp={"nfa_disposition_type"}
                                        fn={(e: ChangeEvent<any>) => this.setState({ nfa_disposition_type: e.target.value || null })}
                                        showBlankFirst={true}
                                    />
                                    <span className={"text-muted small d-block"}>
                                        How NFA items are transferred to this customer. The system auto-infers from FFL number (FFL present
                                        = Form 3, absent = Form 4), but this field overrides that.
                                    </span>
                                </div>
                            )}

                            <div className={"bd-callout"}>
                                <OwLabel title={"ordering_setup"} />
                            </div>

                            <div className={isMasterUser ? "d-none" : ""}>
                                <div>
                                    <OwLabel title={"category"} />
                                    <OwSelectOption
                                        valueProp={"id"}
                                        titleProp={"name"}
                                        options={this.state.categories}
                                        selectedOption={this.state.vendorModel}
                                        selectedOptionProp={"category_id"}
                                        name={"category_id"}
                                        fn={this.handleVendorChange}
                                        showBlankFirst={true}
                                    />
                                </div>

                                {this.props.supplierModel.has_shipping_by_weight ? (
                                    <div>
                                        <OwLabel title={"shipping_zone"} />
                                        <OwSelectOption
                                            valueProp={"id"}
                                            titleProp={"name"}
                                            options={this.state.shippingZones}
                                            selectedOption={this.state.vendorModel}
                                            selectedOptionProp={"shipping_zone_id"}
                                            name={"shipping_zone_id"}
                                            fn={this.handleChange}
                                        />
                                    </div>
                                ) : null}

                                <div className={"mt-4 mb-4"}>
                                    <OwToggle
                                        fn={this.handleVendorChange}
                                        name={"is_ecomm_user"}
                                        label={"is_ecomm_user"}
                                        active={!!this.state.vendorModel.is_ecomm_user}
                                        labelOnRight={true}
                                    />
                                </div>

                                <div className={"mt-4 mb-4"}>
                                    <OwToggle
                                        fn={this.handleVendorChange}
                                        name={"net_term_ecomm_user"}
                                        label={"net_term_ecomm_user"}
                                        disabled={!this.state.vendorModel.is_ecomm_user}
                                        active={!!this.state.vendorModel.net_term_ecomm_user}
                                        labelOnRight={true}
                                    />
                                </div>

                                <div className={"mt-4 mb-4"}>
                                    <OwToggle
                                        fn={this.handleVendorChange}
                                        name={"ecomm_template_items_only"}
                                        label={"ecomm_template_items_only"}
                                        disabled={!this.state.vendorModel.is_ecomm_user}
                                        active={!!this.state.vendorModel.ecomm_template_items_only}
                                        labelOnRight={true}
                                    />
                                </div>

                                {this.state.vendorModel.is_ecomm_user &&
                                (!this.state.vendorModel.lock_catalog_id || !this.state.vendorModel.price_group_id) ? (
                                    <div>
                                        <OwLabel
                                            className={"text-danger"}
                                            title={"must_assign_catalog_and_price_group_to_ecomm_users"}
                                            leftIconClass={"fad fa-octagon-exclamation"}
                                        />
                                    </div>
                                ) : null}

                                <div className={showCatalogSelection ? "" : "d-none"}>
                                    <div>
                                        <OwLabel title={"catalog"} />
                                        <OwSelectOption
                                            options={catalogs}
                                            valueProp={"id"}
                                            titleProp={"name"}
                                            selectedOption={this.state.vendorModel}
                                            selectedOptionProp={"lock_catalog_id"}
                                            fn={(e: any) => {
                                                this.lockCatalog(e);
                                            }}
                                            name={"lock_catalog_id"}
                                            showBlankFirst={true}
                                            isRequired={this.state.vendorModel.is_ecomm_user}
                                        />
                                    </div>

                                    <div>
                                        <OwLabel title={"price_group"} />
                                        <OwSelectOption
                                            showBlankFirst={true}
                                            options={priceGroups}
                                            valueProp={"id"}
                                            selectedOption={this.state.vendorModel}
                                            selectedOptionProp={"price_group_id"}
                                            titleProp={"value"}
                                            fn={(e: any) => {
                                                this.handleVendorChange(e);
                                            }}
                                            name={"price_group_id"}
                                            isRequired={this.state.vendorModel.is_ecomm_user}
                                        />
                                    </div>
                                </div>

                                {this.props.supplierModel.has_commissions ? (
                                    <div className={"mt-3 mb-3"}>
                                        <div>
                                            <OwLabel title={"commission_rate"} />
                                        </div>
                                        <OwInputWrapper
                                            type={"number"}
                                            name={"commission_rate"}
                                            fn={this.handleVendorChange}
                                            value={this.state.vendorModel.commission_rate}
                                            appendText={"%"}
                                        />
                                    </div>
                                ) : null}

                                {this.props.supplierModel.has_vendor_credit_limits ? (
                                    <div className={"mt-3 mb-3"}>
                                        <div>
                                            <OwLabel title={"credit_limit"} />
                                        </div>
                                        <OwInputWrapper
                                            type={"number"}
                                            name={"credit_limit"}
                                            fn={this.handleVendorChange}
                                            value={this.state.vendorModel.credit_limit}
                                        />
                                    </div>
                                ) : null}

                                {hidePricingOption}

                                <div>
                                    <OwLabel title={"payment_type"} />
                                    <OwSelectOption
                                        options={paymentTypes}
                                        valueProp={"value"}
                                        selectedOption={this.state.vendorModel}
                                        selectedOptionProp={"payment_type_id"}
                                        translateTitle={true}
                                        titleProp={"label"}
                                        fn={(e: any) => {
                                            this.handleVendorChange(e);
                                        }}
                                        name={"payment_type_id"}
                                        showBlankFirst={true}
                                    />
                                </div>

                                <div>
                                    <OwLabel
                                        title={"payment_type_name_note"}
                                        showIsReqAsterik={
                                            !!this.state.vendorModel.payment_type_id &&
                                            this.state.vendorModel.payment_type_id !== PaymentTypeEnum.CASH
                                        }
                                    />
                                    <OwInputWrapper
                                        type={"text"}
                                        fn={this.handleVendorChange}
                                        isRequired={
                                            !!this.state.vendorModel.payment_type_id &&
                                            this.state.vendorModel.payment_type_id !== PaymentTypeEnum.CASH
                                        }
                                        name={"payment_type_name"}
                                        value={this.state.vendorModel.payment_type_name}
                                    />
                                </div>

                                {creditCardAuthDocUploader}
                            </div>

                            {this.props.supplierModel.has_payments ? (
                                <div className={"mt-4 mb-4"}>
                                    <OwToggle
                                        fn={this.handleVendorChange}
                                        name={"require_payment"}
                                        label={"require_payment_to_order"}
                                        active={!!this.state.vendorModel.require_payment}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            <div className={"mt-4 mb-4"}>
                                <OwToggle
                                    fn={this.handleVendorChange}
                                    name={"require_po"}
                                    label={"require_po"}
                                    active={!!this.state.vendorModel.require_po}
                                    labelOnRight={true}
                                />
                            </div>

                            <div>
                                <div>
                                    <OwLabel title={"price_adjustment"} />
                                </div>
                                <div>
                                    <OwLabel title={"all_orders"} className={"text-small text-secondary mt-0"} />
                                </div>
                                <OwInputWrapper
                                    showStep={true}
                                    min={0}
                                    step={0.01}
                                    isRequired={false}
                                    name={"price_discount_one"}
                                    fn={this.handleChange}
                                    type={"number"}
                                    value={this.state.price_discount_one}
                                    appendText={"%"}
                                />
                            </div>

                            {this.state.priceGroupsMap.length ? (
                                <div>
                                    <div>
                                        <OwLabel title={"price_adjustment"} noBottomMargin={true} /> %
                                    </div>
                                    <div>
                                        <OwLabel title={"specific_price_groups"} className={"text-small text-secondary mt-0"} />
                                    </div>
                                    {this.state.priceGroupsMap.map((priceGroupsMap: IVendor_Price_Group_Map, index: number) => {
                                        return (
                                            <div key={priceGroupsMap.guid}>
                                                {priceGroupsMap.Price_Group?.Catalog
                                                    ? priceGroupsMap.Price_Group?.Catalog?.name + " - "
                                                    : null}
                                                {priceGroupsMap.Price_Group?.value}
                                                <OwInputWrapper
                                                    type={"number"}
                                                    value={priceGroupsMap.price_adjustment}
                                                    name={"price_adjustment"}
                                                    fn={(e: any) => {
                                                        this.handlePriceGroupAdjustment(e, priceGroupsMap.price_group_id);
                                                    }}
                                                    appendText={"%"}
                                                />
                                                <OwDateInput
                                                    noZIndex={true}
                                                    selectedDate={priceGroupsMap.price_adjustment_expiration}
                                                    fn={(moment: Moment) => {
                                                        this.handlePriceGroupAdjustmentExp(moment, priceGroupsMap.price_group_id);
                                                    }}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : null}

                            {!this.props.supplierModel.Supplier_Integration.has_taxjar && this.state.vendorModel ? (
                                <div>
                                    <div className={"mt-4 mb-4"}>
                                        <OwToggle
                                            fn={this.handleVendorChange}
                                            name={"tax_exempt"}
                                            label={"tax_exempt"}
                                            active={!!this.state.vendorModel.tax_exempt}
                                            labelOnRight={true}
                                        />
                                    </div>
                                    {this.state.vendorModel.Item_Sales_Tax && !this.state.vendorModel.tax_exempt ? (
                                        <div className={"mt-4 mb-4"}>
                                            <OwLabel className={"me-2"} title={"item_sales_tax_rate"} postText={":"} />
                                            {this.state.vendorModel.Item_Sales_Tax.rate}%
                                        </div>
                                    ) : null}
                                </div>
                            ) : null}

                            {this.props.supplierModel.Supplier_Integration.has_taxjar && this.state.vendorModel ? (
                                <div className={"mt-4 mb-4"}>
                                    <div>
                                        <img src={taxJarLogoSrc} height={"16px"} style={{ marginBottom: ".3rem" }} />
                                        <OwLabel title={"tax_exempt"} noBottomMargin={true} className={"ms-2"} />
                                    </div>
                                    <OwSelectOption
                                        options={taxJarExemptionOptions}
                                        titleProp={"value"}
                                        valueProp={"value"}
                                        name={"taxjar_exemption_type"}
                                        fn={this.handleVendorChange}
                                        showBlankFirst={true}
                                        selectedOption={this.state.vendorModel}
                                        selectedOptionProp={"taxjar_exemption_type"}
                                    />
                                </div>
                            ) : null}

                            {this.state.create_in_qbo ? (
                                <div>
                                    <div className={"bd-callout"}>
                                        <img src={qboLogoSrc} height={"16px"} style={{ marginBottom: ".3rem" }} />
                                        <OwLabel title={"quickbooks_online"} className={"ms-2"} />
                                    </div>

                                    <div>
                                        <OwLabel title={"notes"} />
                                        <OwTextArea
                                            name={"qbo_notes"}
                                            fn={() => {}}
                                            value={this.props.supplierVendor?.Vendor?.Vendor_Integration?.qbo_Notes}
                                            disabled={true}
                                        />
                                    </div>

                                    {this.props.supplierModel.Supplier_Integration.qbo_grouped_invoices ? (
                                        <div>
                                            <div className={"mb-2"}>
                                                <OwLabel title={"grouped_invoice_type"} />
                                                <OwSelectOption
                                                    name={"qbo_grouped_invoice_type"}
                                                    options={[
                                                        { value: QBOGroupedInvoiceTypeEnum.STANDARD, title: "standard" },
                                                        { value: QBOGroupedInvoiceTypeEnum.SUM_BY_ORDER, title: "sum_by_order" },
                                                        { value: QBOGroupedInvoiceTypeEnum.GROUPED_BY_DAY, title: "group_by_day" },
                                                    ]}
                                                    translateTitle={true}
                                                    selectedOption={this.state}
                                                    selectedOptionProp={"qbo_grouped_invoice_type"}
                                                    titleProp={"title"}
                                                    valueProp={"value"}
                                                    fn={this.handleChange}
                                                />
                                            </div>
                                        </div>
                                    ) : null}

                                    <div>
                                        <div className={"mb-2"}>
                                            <OwLabel title={"invoice_sale_terms"} />
                                            <OwSelectOption
                                                options={this.state.qboSalesTerms}
                                                valueProp={"Id"}
                                                titleProp={"Name"}
                                                fn={this.handleChange}
                                                selectedOption={this.state}
                                                selectedOptionProp={"qbo_SalesTermRef"}
                                                name={"qbo_SalesTermRef"}
                                                showBlankFirst={true}
                                            />
                                        </div>
                                    </div>

                                    {this.props.userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN ? (
                                        <div className={"mb-2"}>
                                            <OwLabel title={"invoice_class"} />
                                            <OwSelectOption
                                                options={this.state.qboClasses}
                                                valueProp={"Id"}
                                                titleProp={"Name"}
                                                fn={this.handleChange}
                                                selectedOption={this.state}
                                                selectedOptionProp={"qbo_InvoiceClassRef"}
                                                name={"qbo_InvoiceClassRef"}
                                                showBlankFirst={true}
                                            />
                                        </div>
                                    ) : null}

                                    <div>
                                        <OwLabel title={"tax_rate"} />
                                        <OwSelectOption
                                            fn={() => {}}
                                            name={"qbo_TaxRateRef"}
                                            selectedOption={this.props.supplierVendor?.Vendor?.Vendor_Integration?.qbo_DefaultTaxCodeRef}
                                            selectedOptionProp={"value"}
                                            options={this.state.qboTaxRates}
                                            valueProp={"Id"}
                                            titleProp={"Name"}
                                            isDisabled={true}
                                        />
                                    </div>

                                    <div className={"mb-2"}>
                                        <OwLabel title={"manual_customer_lookup"} />
                                        <TypeaheadFn
                                            lookupFn={this.searchQboCustomers}
                                            availableOptions={this.state.qboCustomerSearchResults}
                                            selectedOption={this.state.selectedQboCustomer}
                                            selectedOptionFn={this.onSelectQboCustomer}
                                            titleProp={"DisplayName"}
                                            subTitleProp={"CompanyName"}
                                            valueProp={"Id"}
                                            placeholder={"Search Customers"}
                                            isScrollable={true}
                                            maxHeight={200}
                                            emitSelectionSetup={{ emitObject: true }}
                                            clearSelectionFn={() => this.setState({ selectedQboCustomer: null })}
                                        />
                                    </div>

                                    {this.state.vendorModel.Vendor_Integration?.qbo_DisplayName ? (
                                        <div className={"mt-3"}>
                                            <OwLabel isBold={true} className={"me-2"} title={"current_customer"} postText=":" />
                                            {this.state.vendorModel.Vendor_Integration?.qbo_DisplayName}
                                        </div>
                                    ) : null}

                                    {this.state.vendorModel.Vendor_Integration &&
                                    this.props.supplierModel.Supplier_Integration.has_qbo &&
                                    !this.state.vendorModel.Vendor_Integration.qbo_CustomerId &&
                                    !this.state.selectedQboCustomer ? (
                                        <div className={"mt-3"}>
                                            <OwButton
                                                title={"push_to_quickbooks_online"}
                                                fn={this.pushToQbo}
                                                active={this.state.pushToQboActive}
                                                disableOnActive={true}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            ) : null}

                            {this.props.supplierModel.Supplier_Integration.has_qbd ? (
                                <div>
                                    <div className={"bd-callout"}>
                                        <OwLabel title={"quickbooks_desktop"} />
                                    </div>

                                    <div>
                                        <OwLabel title={"term_option"} />
                                        <div>
                                            <OwSelectOption
                                                name={"qbd_TermOptionListID"}
                                                selectedOption={this.state}
                                                selectedOptionProp={"qbd_TermOptionListID"}
                                                options={qbd_TermOptions}
                                                titleProp={"Name"}
                                                valueProp={"ListID"}
                                                fn={this.handleChange}
                                                showBlankFirst={true}
                                            />
                                        </div>
                                    </div>
                                    <div className={"mt-2"}>
                                        <OwLabel title={"preferred_delivery_method"} postText={":"} className={"me-2"} />
                                        {this.state.vendorModel.Vendor_Integration?.qbd_PreferredDeliveryMethod}
                                    </div>
                                    <div className={"mt-2"}>
                                        <OwToggle
                                            fn={this.handleChange}
                                            name={"qbd_skip_sending"}
                                            label={"skip_sending"}
                                            active={!!this.state.qbd_skip_sending}
                                            labelOnRight={true}
                                        />
                                    </div>
                                    <div className={"mt-2"}>
                                        <OwToggle
                                            fn={this.handleChange}
                                            name={"qbd_skip_updating"}
                                            label={"skip_updating"}
                                            active={!!this.state.qbd_skip_updating}
                                            labelOnRight={true}
                                        />
                                    </div>
                                </div>
                            ) : null}

                            {hasConfirmShipTo ? (
                                <div>
                                    <OwToggle
                                        fn={this.handleVendorChange}
                                        name={"require_confirm_ship_to"}
                                        label={"require_confirm_ship_to"}
                                        active={!!this.state.vendorModel.require_confirm_ship_to}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            <div className={hasOrderBonus ? "" : "d-none"}>
                                <OwToggle
                                    fn={this.handleVendorChange}
                                    name={"has_order_bonus"}
                                    label={"has_order_bonus"}
                                    active={!!this.state.vendorModel.has_order_bonus}
                                    labelOnRight={true}
                                />
                            </div>

                            {this.state.vendorModel.has_order_bonus ? (
                                <div>
                                    <OwInputWrapper
                                        value={this.state.vendorModel.order_bonus_perc}
                                        name={"order_bonus_perc"}
                                        fn={this.handleVendorChange}
                                        placeholder={"order_bonus_perc"}
                                        type={"number"}
                                        appendText={"%"}
                                    />
                                </div>
                            ) : null}

                            {this.props.supplierModel.has_rebates ? (
                                <div className={"mt-2"}>
                                    <OwLabel title={"rebate_group"} />
                                    <OwSelectOption
                                        options={this.state.rebate_groups}
                                        valueProp={"id"}
                                        titleProp={"name"}
                                        fn={this.handleVendorChange}
                                        selectedOption={this.state.vendorModel}
                                        selectedOptionProp={"rebate_group_id"}
                                        name={"rebate_group_id"}
                                        showBlankFirst={true}
                                    />
                                </div>
                            ) : null}

                            {this.props.supplierModel.has_vendor_priority ? (
                                <div>
                                    <OwLabel title={"priority"} />
                                    <OwInputWrapper
                                        type={"number"}
                                        value={this.state.vendorModel.priority}
                                        fn={this.handleVendorChange}
                                        name={"priority"}
                                    />
                                </div>
                            ) : null}

                            <div className={"bd-callout"}>
                                <OwLabel title={"shipping_setup"} />
                            </div>

                            <div className={"mt-2"}>
                                <OwLabel title={"default_shipping_instructions"} />
                                <div>
                                    <OwTextArea
                                        name={"default_shipping_instructions"}
                                        fn={this.handleVendorChange}
                                        value={this.state.vendorModel.default_shipping_instructions}
                                    />
                                </div>
                            </div>

                            {this.props.supplierModel.has_local_delivery ? (
                                <div className={"mt-2"}>
                                    <OwToggle
                                        fn={this.handleVendorChange}
                                        name={"default_local_delivery"}
                                        label={"default_local_delivery"}
                                        active={!!this.state.vendorModel.default_local_delivery}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            {this.props.supplierModel.has_local_pickup ? (
                                <div className={"mt-2"}>
                                    <OwToggle
                                        fn={this.handleVendorChange}
                                        name={"default_local_pickup"}
                                        label={"default_local_pickup"}
                                        active={!!this.state.vendorModel.default_local_pickup}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            {this.props.supplierModel.Supplier_Integration.has_shipstation ? (
                                <div>
                                    {this.state.shipstationCarriers.length ? (
                                        <div>
                                            <ShippingAccounts
                                                updateShippingAccounts={this.updateShippingAccounts}
                                                shippingAccounts={this.state.vendorModel.Shipping_Accounts || []}
                                                shipstationCarriers={this.state.shipstationCarriers}
                                                userModel={this.props.userModel}
                                                supplierModel={this.props.supplierModel}
                                                socket={this.props.socket}
                                                notifyFn={this.props.notifyFn}
                                                shipstationWarehouses={this.state.shipstationWarehouses}
                                            />

                                            <ShippingUpchargeDetails
                                                shipstationCarriers={this.state.shipstationCarriers}
                                                shippingDetails={this.state.vendorModel.Shipping_Details || []}
                                                updateShippingDetails={this.updateShippingDetails}
                                                userModel={this.props.userModel}
                                                supplierModel={this.props.supplierModel}
                                                socket={this.props.socket}
                                                notifyFn={this.props.notifyFn}
                                            />
                                        </div>
                                    ) : (
                                        <LoadingResults />
                                    )}
                                </div>
                            ) : null}

                            {this.props.supplierModel.has_order_categories ? (
                                <div>
                                    <div>
                                        <OwLabel title={"default_order_category"} />
                                    </div>
                                    <div>
                                        <OwSelectOption
                                            fn={this.handleVendorChange}
                                            options={this.state.orderCategories}
                                            valueProp={"id"}
                                            titleProp={"name"}
                                            selectedOption={this.state.vendorModel}
                                            selectedOptionProp={"default_order_category_id"}
                                            name={"default_order_category_id"}
                                            showBlankFirst={true}
                                        />
                                    </div>
                                </div>
                            ) : null}

                            {this.props.supplierModel.has_delivery_deadlines && this.state.vendorModel.guid ? (
                                <div className={"mt-3"}>
                                    <div className={"bd-callout"}>
                                        <OwLabel title={"delivery_deadlines"} />
                                    </div>

                                    <DeliveryDeadlinesSection vendorGuid={this.state.vendorModel.guid} />

                                    <div className={"mt-2"}>
                                        <OwLabel title={"vendor_timezone"} noBottomMargin={true} />
                                        <TimezonePicker
                                            value={this.state.vendorModel.timezone}
                                            ariaLabel={"vendor timezone"}
                                            onChange={(value) => this.handleVendorChange({ target: { name: "timezone", value } } as any)}
                                        />
                                        <OwLabel
                                            title={"timezone_fallback_helper"}
                                            className={"text-muted small"}
                                            postText={this.props.supplierModel.timezone ? ` ${this.props.supplierModel.timezone}` : ""}
                                        />
                                    </div>
                                </div>
                            ) : null}

                            {/*<div className={allowSquareCreate? '' : 'd-none'}>*/}
                            {/*<OwCheckbox*/}
                            {/*label={'create_in_square'}*/}
                            {/*name={'create_in_square'}*/}
                            {/*checked={this.state.create_in_square}*/}
                            {/*fn={this.handleSupplierChange}*/}
                            {/*/>*/}
                            {/*</div>*/}

                            <div className={isMasterUser ? "mt-2" : "d-none"}>
                                <MasterUser
                                    icon={"far fa-building"}
                                    title={"supplier_vendor_account"}
                                    isMaster={isMasterUser}
                                    isSupplierVendorOverride={true}
                                    supplierModel={this.props.supplierModel}
                                />
                            </div>

                            {allowQuickBooksCreate ? (
                                <div className={"mt-2"}>
                                    <OwToggle
                                        label={"create_in_quickbooks_online"}
                                        name={"create_in_qbo"}
                                        active={this.state.create_in_qbo}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            {allowQuickBooksDesktopCreate ? (
                                <div className={"mt-2"}>
                                    <OwToggle
                                        label={"create_in_quickbooks_desktop"}
                                        name={"create_in_qbd"}
                                        active={this.state.create_in_qbd}
                                        fn={this.handleChange}
                                    />
                                </div>
                            ) : null}
                        </form>
                    </div>
                    <div style={{ minHeight: "7vh" }}>
                        {this.state.vendorModel.is_ecomm_user &&
                        (!this.state.vendorModel.lock_catalog_id || !this.state.vendorModel.price_group_id) ? (
                            <div className={"mb-2"}>
                                <OwLabel
                                    className={"text-danger"}
                                    title={"must_assign_catalog_and_price_group_to_ecomm_users"}
                                    leftIconClass={"fad fa-octagon-exclamation"}
                                />
                            </div>
                        ) : null}
                        <div className={"mt-2"}>
                            <OwButton
                                className={"btn-success me-2"}
                                fn={() => {
                                    this.saveVendor();
                                }}
                                title={"save"}
                                disabled={!this.state.isFormValid}
                                active={this.state.isSaving}
                                disableOnActive={true}
                            />

                            <OwButton className={"btn-danger"} fn={this.cancel} title={"cancel"} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default VendorSidebar;

const LoadingOverlay = styled.div`
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 2;
`;
